<div fxLayoutAlign="center center">
    <div fxLayout="column" fxFlex="60" fxFlex.md="70" fxFlex.sm="80" fxFlex.xs="95">
        
        <div [fxHide]="studentStype != 1">
            <app-disclaimercontent></app-disclaimercontent>
        </div>
        <div [fxHide]="studentStype == 1">
            <app-disclaimercontentoversees></app-disclaimercontentoversees>
        </div>

        <div fxFlex="row" class="navigation-container">
            <div fxFlex="50" fxLayoutAlign="start center">
                <button mat-button [routerLink]="['/default']" class="navigation-button navigation-button-back">Back</button>
            </div>
            <div fxFlex="50" fxLayoutAlign="end center">
                <button mat-button [routerLink]="['/default', {outlets: {'main': ['programme']}}]" class="navigation-button navigation-button-proceed">Accept</button>
            </div>
        </div>
    </div>
</div>